/**
 * Web: react-native-linear-gradient uses requireNativeComponent (no RN Web support).
 * Skeleton placeholder expects the same API; expo-linear-gradient supports web.
 */
'use strict';

const { LinearGradient } = require('expo-linear-gradient');

module.exports = LinearGradient;
